<button
  mat-stroked-button
  color="primary"
  class="button-view-btn"
  [class.active-button]="currentlySelectedFilters.length > 0 && matSelect.triggerValue"
  *ngIf="buttonView; else inputView"
  (click)="matSelect.toggle()"
>
  <ng-container
    *ngIf="currentlySelectedFilters.length as numberOfSelectedFilters; else placeholder"
  >
    <span class="dropdown-label" *ngIf="numberOfSelectedFilters === 1">
      {{ matSelect.triggerValue }}
      {{
        matSelect.triggerValue
          ? ''
          : ('+INSTALLATIONS.KANBAN_DASHBOARD.HEADER.FILTER_PLANTS' | translate)
      }}
      <mat-icon class="arrow-icon"> expand_more </mat-icon></span
    >
    <span class="dropdown-label" *ngIf="numberOfSelectedFilters > 1"
      >{{ '+ASSISTANT.SEARCH.SELECTED_FILTERS' | translate }} :
      {{ matSelect.triggerValue.split(',').length }}
      <mat-icon class="arrow-icon"> expand_more </mat-icon></span
    ></ng-container
  >
  <ng-template #placeholder>
    <span class="dropdown-label">
      {{ '+INSTALLATIONS.KANBAN_DASHBOARD.HEADER.FILTER_PLANTS' | translate }}
      <mat-icon class="arrow-icon"> expand_more </mat-icon>
    </span>
  </ng-template>

  <ng-container *ngTemplateOutlet="matField"></ng-container>
</button>

<ng-template #inputView>
  <ng-container *ngTemplateOutlet="matField"></ng-container>
</ng-template>

<ng-template #matField>
  <mat-form-field mat-select-height-small [class.button-view]="buttonView">
    <mat-select
      #matSelect
      [compareWith]="compareFilterOptions"
      multiple
      [formControl]="selectedFilters"
      [disableOptionCentering]="false"
      [placeholder]="
        buttonView ? '' : ('+INSTALLATIONS.KANBAN_DASHBOARD.HEADER.FILTER_PLANTS' | translate)
      "
      [panelClass]="'dashboard-filter-list-panel'"
      gtm="onOpen"
      gtmAction="Open filter dropdown"
      gtmCategory="Installation list"
      data-at-installations-filter-field
    >
      <ng-container *ngFor="let filterGroup of filters$ | async">
        <ng-container [ngSwitch]="filterGroup.type">
          <!-- Complex -->
          <ng-container *ngSwitchCase="filterType.Complex">
            <mat-optgroup [label]="filterGroup.filterName | dashboardFilterTranslation">
              <mat-option *ngFor="let filter of filterGroup.filters" [value]="filter">{{
                filter.label | dashboardFilterTranslation: filterGroup.filterName
              }}</mat-option>
            </mat-optgroup>
          </ng-container>
          <!-- Toggle -->
          <ng-container *ngSwitchCase="filterType.Toggle">
            <!-- Toggle filter has filters array with only 1 element; done to keep type consistency -->
            <mat-optgroup
              *ngIf="filterGroup.filters[0] as filter"
              [label]="filter.label | dashboardFilterTranslation"
            >
              <mat-option [value]="filter">{{
                filter.label | dashboardFilterTranslation
              }}</mat-option>
            </mat-optgroup>
          </ng-container>
        </ng-container>
      </ng-container>
    </mat-select>
  </mat-form-field>
</ng-template>
